/* istanbul ignore file */
export enum SEGMENT {
    /**
     * @value Absolute date
     */
    ABSOLUTE_DATE = 'SEGMENT.ABSOLUTE_DATE',
    /**
     * @value Account creation date
     * @description Date of the creation of the lumapps user account . Used in segment
     */
    ACCOUNT_CREATION_DATE = 'SEGMENT.ACCOUNT_CREATION_DATE',
    /**
     * @value First session date
     * @description Date of the first session for a given user account. Used in segment
     */
    ACCOUNT_FIRST_SESSION = 'SEGMENT.ACCOUNT_FIRST_SESSION',
    /**
     * @value Account information
     * @description Subheader for the system dates attributes in segment
     */
    ACCOUNT_INFO_SUBHEADER = 'SEGMENT.ACCOUNT_INFO_SUBHEADER',
    /**
     * @value Last session date
     * @description Last session date for a given user account. Used in segment
     */
    ACCOUNT_LAST_SESSION = 'SEGMENT.ACCOUNT_LAST_SESSION',
    /**
     * @value is any of
     */
    ANY_OF_OPERATOR = 'SEGMENT.ANY_OF_OPERATOR',
    /**
     * @value Attribute
     */
    ATTRIBUTE_SELECT_LABEL = 'SEGMENT.ATTRIBUTE_SELECT_LABEL',
    /**
     * @value Availability
     */
    AVAILABILITY = 'SEGMENT.AVAILABILITY',
    /**
     * @value Segment availability
     */
    AVAILABLE_FOR_CONTENT = 'SEGMENT.AVAILABLE_FOR_CONTENT',
    /**
     * @value Calculate size
     */
    CALCULATE_SEGMENT_SIZE = 'SEGMENT.CALCULATE_SEGMENT_SIZE',
    /**
     * @value Calculating...
     */
    CALCULATING_SEGMENT_SIZE = 'SEGMENT.CALCULATING_SEGMENT_SIZE',
    /**
     * @value contains
     */
    CONTAINS_OPERATOR = 'SEGMENT.CONTAINS_OPERATOR',
    /**
     * @value Continue editing
     */
    CONTINUE_EDITING = 'SEGMENT.CONTINUE_EDITING',
    /**
     * @value Create segment
     */
    CREATE_SEGMENT = 'SEGMENT.CREATE',
    /**
     * @value Create segment
     */
    CREATE_SEGMENT_MODAL_TITLE = 'SEGMENT.CREATE_SEGMENT_MODAL_TITLE',
    /**
     * @value At least one condition is needed
     */
    DELETE_CRITERIA_TOOLTIP = 'SEGMENT.DELETE_CRITERIA_TOOLTIP',
    /**
     * @value Deploying the segment outside broadcast may take a few minutes
     */
    DEPLOY_INFORMATION = 'SEGMENT.DEPLOY_INFORMATION',
    /**
     * @value Deploying...
     */
    DEPLOY_RUNNING = 'SEGMENT.DEPLOY_RUNNING',
    /**
     * @value Describe the segment constitution for a better usage of it.
     */
    DESCRIPTION_HELPER = 'SEGMENT.DESCRIPTION_HELPER',
    /**
     * @value Edit segment
     */
    EDIT_SEGMENT_MODAL_TITLE = 'SEGMENT.EDIT_SEGMENT_MODAL_TITLE',
    /**
     * @value is empty
     */
    EMPTY_OPERATOR = 'SEGMENT.EMPTY_OPERATOR',
    /**
     * @value ends with
     */
    ENDS_WITH_OPERATOR = 'SEGMENT.ENDS_WITH_OPERATOR',
    /**
     * @value Enter a value
     */
    ENTER_A_VALUE = 'SEGMENT.ENTER_A_VALUE',
    /**
     * @value Include
     */
    INCLUDE = 'SEGMENT.INCLUDE',
    /**
     * @value This segment contains all people where:
     */
    INCLUDE_DESCRIPTION = 'SEGMENT.INCLUDE_DESCRIPTION',
    /**
     * @value Is in CSV
     */
    IN_CSV_OPERATOR = 'SEGMENT.IN_CSV_OPERATOR',
    /**
     * @value A segment cannot contain more than 5 “is in CSV” or “is not in CSV”
     */
    IN_CSV_TOOLTIP = 'SEGMENT.IN_CSV_TOOLTIP',
    /**
     * @value is after
     * @description Operator used in segment admin for dates
     */
    IS_AFTER_OPERATOR = 'SEGMENT.IS_AFTER_OPERATOR',
    /**
     * @value is before
     * @description Operator used in segment admin for dates
     */
    IS_BEFORE_OPERATOR = 'SEGMENT.IS_BEFORE_OPERATOR',
    /**
     * @value is in the last
     */
    IS_IN_THE_LAST_OPERATOR = 'SEGMENT.IS_IN_THE_LAST_OPERATOR',
    /**
     * @value is in the next
     */
    IS_IN_THE_NEXT_OPERATOR = 'SEGMENT.IS_IN_THE_NEXT_OPERATOR',
    /**
     * @value is never
     * @description Operator used in segment admin for dates
     */
    IS_NEVER_OPERATOR = 'SEGMENT.IS_NEVER_OPERATOR',
    /**
     * @value is not in the last
     */
    IS_NOT_IN_THE_LAST_OPERATOR = 'SEGMENT.IS_NOT_IN_THE_LAST_OPERATOR',
    /**
     * @value is not in the next
     */
    IS_NOT_IN_THE_NEXT_OPERATOR = 'SEGMENT.IS_NOT_IN_THE_NEXT_OPERATOR',
    /**
     * @value are not
     * @description Operator used in segment when selecting the 'People' attribute. Allow segment creator to exclude specific people from a segment.
     * Example:
     * Attribute: People
     * Operator: Are not
     * Selected users: John Doe, Jane Doe
     * => John and Jane will NOT be part of the segment
     */
    IS_NOT_OPERATOR = 'SEGMENT.IS_NOT_OPERATOR',
    /**
     * @value is on
     * @description Operator used in segment admin for dates
     */
    IS_ON_OPERATOR = 'SEGMENT.IS_ON_OPERATOR',
    /**
     * @value are
     * @description Operator used in segment when selecting the 'People' attribute. Allow segment creator to add specific people to a segment.
     * Example:
     * Attribute: People
     * Operator: Are
     * Selected users: John Doe, Jane Doe
     * => John and Jane will be part of the segment
     */
    IS_OPERATOR = 'SEGMENT.IS_OPERATOR',
    /**
     * @value is this
     */
    IS_THIS_OPERATOR = 'SEGMENT.IS_THIS_OPERATOR',
    /**
     * @value New segment
     */
    NEW_SEGMENT = 'SEGMENT.NEW',
    /**
     *
     */
    NOTIF_MAX_AND_BLOCKS_REACHED = 'SEGMENT.NOTIF_MAX_AND_BLOCKS_REACHED ',
    /**
     *
     */
    NOTIF_MAX_OR_BLOCKS_PER_AND_BLOCK_REACHED = 'SEGMENT.NOTIF_MAX_OR_BLOCKS_PER_AND_BLOCK_REACHED',
    /**
     * @value Maximum number of values reached (%LIMIT%)
     */
    NOTIF_MAX_VALUES_REACHED = 'SEGMENT.NOTIF_MAX_VALUES_REACHED',
    /**
     * @value does not contain
     */
    NOT_CONTAINS_OPERATOR = 'SEGMENT.NOT_CONTAINS_OPERATOR',
    /**
     * @value is not empty
     */
    NOT_EMPTY_OPERATOR = 'SEGMENT.NOT_EMPTY_OPERATOR',
    /**
     * @value does not end with
     */
    NOT_ENDS_WITH_OPERATOR = 'SEGMENT.NOT_ENDS_WITH_OPERATOR',
    /**
     * @value Is not in CSV
     */
    NOT_IN_CSV_OPERATOR = 'SEGMENT.NOT_IN_CSV_OPERATOR',
    /**
     * @value is none of
     */
    NOT_IN_OPERATOR = 'SEGMENT.NOT_IN_OPERATOR',
    /**
     * @value does not starts with
     */
    NOT_STARTS_WITH_OPERATOR = 'SEGMENT.NOT_STARTS_WITH_OPERATOR',
    /**
     * @value Operator
     */
    OPERATOR_SELECT_LABEL = 'SEGMENT.OPERATOR_SELECT_LABEL',
    /**
     * @value Relative date
     */
    RELATIVE_DATE = 'SEGMENT.RELATIVE_DATE',
    /**
     * @value The segment is based on a user profile field that no longer exists. Edit segment to assign a new attribute.
     */
    REMOVED_USER_PROFILE_FIELDS_LIST_HELPER = 'SEGMENT.REMOVED_USER_PROFILE_FIELDS_LIST_HELPER',
    /**
     * @value User profile field no longer exists
     */
    REMOVED_USER_PROFILE_FIELD_FORM_HELPER = 'SEGMENT.REMOVED_USER_PROFILE_FIELD_FORM_HELPER',
    /**
     * @value Rules
     */
    RULES = 'SEGMENT.RULES',
    /**
     * @value Segments
     */
    SEGMENTS = 'SEGMENT.SEGMENTS',
    /**
     * @value Segment archived
     * @description Text displayed in notification when archiving a segment
     */
    SEGMENT_ARCHIVED_NOTIF = 'SEGMENT.SEGMENT_ARCHIVED_NOTIF',
    /**
     * @value Segment created
     */
    SEGMENT_CREATED_NOTIF = 'SEGMENT.SEGMENT_CREATED_NOTIF',
    /**
     * @value A file is required
     * @description Error message displayed when user tries to save a segment with a csv based rule without any csv file uploaded
     */
    SEGMENT_CSV_NOT_UPLOADED_ERROR_MESSAGE = 'SEGMENT.CSV_NOT_UPLOADED_ERROR_MESSAGE',
    /**
     * @value Description in %LANG%
     * @description Label displayed above segment description. It is possible to have a description per language which is why there is a variable %LANG%.
     */
    SEGMENT_DESCRIPTION_LABEL = 'SEGMENT.DESCRIPTION_LABEL',
    /**
     * @value Segment edited
     */
    SEGMENT_EDITED_NOTIF = 'SEGMENT.SEGMENT_EDITED_NOTIF',
    /**
     * @value A segment cannot contain more than 10 groups of conditions.
     * @description Warning message displayed in segment admin when 10 AND blocks for the same segment have been created
     */
    SEGMENT_FORM_AND_BLOCK_MAX_LIMIT_REACHED = 'SEGMENT_FORM_AND_BLOCK_MAX_LIMIT_REACHED',
    /**
     * @value A group of conditions cannot contain more than 10 conditions.
     * @description Warning displayed when more than 10 rules have been added to an OR block.
     */
    SEGMENT_FORM_OR_BLOCK_MAX_LIMIT_REACHED = 'SEGMENT_FORM_OR_BLOCK_MAX_LIMIT_REACHED',
    /**
     * @value Segment last deployed on %DATE%
     */
    SEGMENT_LAST_DEPLOYED_ON = 'SEGMENT.SEGMENT_LAST_DEPLOYED_ON',
    /**
     * @value Segment last updated on %DATE%
     */
    SEGMENT_LAST_UPDATED_ON = 'SEGMENT.LAST_UPDATED_ON',
    /**
     * @value Deploy segment outside Broadcasts
     */
    SEGMENT_OUTSIDE_BROADCAST = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST',
    /**
     * @value This segment is deployed outside Broadcasts.
     */
    SEGMENT_OUTSIDE_BROADCAST_DETAILS = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_DETAILS',
    /**
     * @value When deployed, the segment is also available in:
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER',
    /**
     * @value Directory entries (in "visible by" and "force entry")
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_DIRECTORY_ENTRIES = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_DIRECTORY_ENTRIES',
    /**
     * @value Play roles
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_PLAY_ROLES = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_PLAY_ROLES',
    /**
     * @value Play video visibility restriction
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_PLAY_VIDEO_VISIBILITY_RESTRICTION = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_PLAY_VIDEO_VISIBILITY_RESTRICTION',
    /**
     * @value Promoted search
     * @description Name of the "promote" feature
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_PROMOTED_SEARCH = 'ADMIN.FEATURES.PROMOTED_RESULTS.NAME',
    /**
     * @value Site navigation
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_SITE_NAVIGATION = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_SITE_NAVIGATION',
    /**
     * @value Content templates permissions
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_TEMPLATE_PERMISSIONS = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_TEMPLATE_PERMISSIONS',
    /**
     * @value Analytics (as a filter)
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_USABLE_IN_ANALYTICS = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_USABLE_IN_ANALYTICS',
    /**
     * @value Content (in “visible by” and “highlighted for”)
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_USABLE_IN_CONTENT = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_USABLE_IN_CONTENT',
    /**
     * @value Widget visibility
     */
    SEGMENT_OUTSIDE_BROADCAST_HELPER_WIDGET_VISIBILITY = 'SEGMENT.SEGMENT_OUTSIDE_BROADCAST_HELPER_WIDGET_VISIBILITY',
    /**
     * @deprecated use ReferToDocumentation component instead
     * @value For more information, refer to the %MORE_INFO_LINK%
     * @description Description that gives a link to user to have more information on segment properties.
     * Link key:
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=336584072
     */
    SEGMENT_PROPERTIES_DESCRIPTION = 'SEGMENT.PROPERTIES_DESCRIPTION',
    /**
     * @value documentation
     * @description Link used in key https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=336583096
     */
    SEGMENT_PROPERTIES_MORE_INFO_LINK = 'SEGMENT.PROPERTIES_MORE_INFO_LINK',
    /**
     * @value This segment can be used as a filter in the analytics dashboards.
     */
    SEGMENT_PROPERTY_ANALYTICS_DRAWER_DESCRIPTION = 'SEGMENT.SEGMENT_PROPERTY_ANALYTICS_DRAWER_DESCRIPTION',
    /**
     * @value Used as a filter
     */
    SEGMENT_PROPERTY_ANALYTICS_HELPER = 'SEGMENT.SEGMENT_PROPERTY_ANALYTICS_HELPER',
    /**
     * @value This segment is available in the "visible by" and "highlighted for" fields when creating content.
     * @description Description displayed in segment drawer only when the property highlight is activated
     */
    SEGMENT_PROPERTY_PROMOTION_DRAWER_DESCRIPTION = 'SEGMENT.PROPERTY_PROMOTION_DRAWER_DESCRIPTION',
    /**
     * @value In the 'visible by' and 'highlighted for' fields
     */
    SEGMENT_PROPERTY_PROMOTION_HELPER = 'SEGMENT.PROPERTY_PROMOTION_HELPER',
    /**
     * @value Allow highlighting content for this segment and limiting the visibility of content to this segment
     * @description Option that allows user to create a group based on a segment
     */
    SEGMENT_PROPERTY_PROMOTION_LABEL = 'SEGMENT.PROPERTY_PROMOTION_LABEL',
    /**
     * @value Segment provisioning takes up to 24 hours when used in multiple features.
     */
    SEGMENT_PROPERTY_PROMOTION_WARNING = 'SEGMENT.SEGMENT_PROPERTY_PROMOTION_WARNING',
    /**
     * @value %ATTRIBUTE% %OPERATOR% %VALUES%
     * @description PLEASE READ AND CHECK SCREENSHOT BEFORE TRANSLATING:
     * This string allows you to change the order of segment rule description. Segment rules are composed of 3 elements: an attribute, an operator and values. By moving around the 3 variables you can change their order to make it more understandable in your language. Further more you can add space, punctuation or even words to make it clearer in your own language. Some example below:
     * With extra words : attribute: %ATTRIBUTE% operator: %OPERATOR% values: %VALUES%
     * With different order: %OPERATOR% %ATTRIBUTE% %VALUES%
     * With double byte spaces (for Asian languages for instance): %ATTRIBUTE% %OPERATOR% %VALUES%
     *
     * Please find below the list of operators and attributes that can be used here (values are not translatable from lokalize). This is only for your information. Please do not update translations of these items. Use this string instead to make rule description work in your language:
     * ATTRIBUTES:
     * GLOBAL.GROUP
     * GLOBAL.PEOPLE
     * Note: all other attributes comes from lumapps user profil. They cannot be translated from lokalise.
     *
     * OPERATORS:
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=200837606
     * SEGMENT.ANY_OF_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=210467850a
     * SEGMENT.STARTS_WITH_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=219999555
     * SEGMENT.ENDS_WITH_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=219591296
     * SEGMENT.NOT_IN_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=219625541
     * SEGMENT.EMPTY_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=220139826
     * SEGMENT.NOT_EMPTY_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=219606467
     * SEGMENT.CONTAINS_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=222564569
     * SEGMENT.NOT_CONTAINS_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=221273945
     * SEGMENT.NOT_ENDS_WITH_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=418115847
     * SEGMENT.IS_OPERATOR
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=418116637
     * SEGMENT.IS_NOT_OPERATOR
     *
     */
    SEGMENT_RULE_DESCRIPTION = 'SEGMENT.SEGMENT_RULE_DESCRIPTION',
    /**
     * @value This segment has been archived. If you unselect it, you will not able to select it again.
     */
    SEGMENT_SELECTED_BUT_ARCHIVED_HELPER = 'SEGMENT.SEGMENT_SELECTED_BUT_ARCHIVED_HELPER',
    /**
     * @value Segment unarchived
     * @description Notification displayed when a user unarchived a segment
     */
    SEGMENT_UNARCHIVED_NOTIF = 'SEGMENT.SEGMENT_UNARCHIVED_NOTIF',
    /**
     * @value starts with
     */
    STARTS_WITH_OPERATOR = 'SEGMENT.STARTS_WITH_OPERATOR',
    /**
     * @value Timescale
     */
    TIMESCALE = 'SEGMENT.TIMESCALE',
    /**
     * @value Unknown operator
     */
    UNKNOWN_OPERATOR = 'SEGMENT.UNKNOWN_OPERATOR',
    /**
     * @value Only the first column will be used for the segment
     */
    UPLOAD_COLUMN_USED = 'SEGMENT.UPLOAD_COLUMN_USED',
    /**
     * @value Upload CSV file
     */
    UPLOAD_CSV_FILE_TITLE = 'SEGMENT.UPLOAD_CSV_FILE_TITLE',
    /**
     * @value The file must respect these rules:
     */
    UPLOAD_FILE_RULES_INTRO = 'SEGMENT.UPLOAD_FILE_RULES_INTRO',
    /**
     * @value Use only "," and ";" between the values
     */
    UPLOAD_SUPPORTED_SEPARATORS = 'SEGMENT.UPLOAD_SUPPORTED_SEPARATORS',
    /**
     * @value Use
     */
    USE = 'SEGMENT.USE',
    /**
     * @value User profile information
     */
    USER_PROFILE_INFO = 'SEGMENT.USER_PROFILE_INFO',
    /**
     * @value Value
     */
    VALUE = 'SEGMENT.VALUE',
    /**
     * @value year
     * @description Used in segment admin for year value. Used with operator 'is this' (https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=458815219).
     * example: Account creation date is this year
     */
    YEAR = 'SEGMENT.YEAR',
}
